"use client"

import { ALERT_EVENTS } from "@/src/lib/constants"
import { useListener } from "./useListener"
import { useToast } from "../components/ui/use-toast"

export function useToastListener() {
  const { toast } = useToast()

  // Listen for success events
  useListener(
    ALERT_EVENTS.SUCCESS,
    (message: string) => {
      toast({
        description: (
          <div className="text-white  leading-relaxed">
            {message}
          </div>
        ),
        variant: "default",
        className: `
          fixed top-0 right-0 w-screen mx-0 z-[100]
          bg-green-600
         
          text-white shadow-2xl rounded-lg p-8 backdrop-blur-sm
          animate-in slide-in-from-top-4 duration-700 ease-out
          hover:shadow-3xl transition-all
        `,
        duration: 4000,
      })
    },
    [toast],
  )

  // Listen for error events
  useListener(
    ALERT_EVENTS.ERROR,
    (message: string) => {
      toast({
        description: (
          <div className="text-white text-center flex center justify-center leading-relaxed">
            {message}
          </div>
        ),
        variant: "destructive",
        className: `
          fixed top-0 right-0 w-screen mx-0 center  z-[100]
          bg-red-600
       
          text-white shadow-2xl rounded-lg p-8 backdrop-blur-sm
          animate-in slide-in-from-top-4 duration-700 ease-out
          hover:shadow-3xl transition-all
        `,
        duration: 5000,
      })
    },
    [toast],
  )
}
